export default "/images/vendor/flag-icon-css/flags/1x1/hm.svg?0df90608875d9e335553a299c0f074a5";